/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../../generated/graphqlTypes";

import { gql } from "@apollo/client";
export type DatabaseSearchResultsForSqlCompletionFragment = {
  readonly __typename: "DatabaseSearchResults";
  readonly databaseResultCount: number;
  readonly databaseSearchResults: ReadonlyArray<{
    readonly __typename: "DataSourceDatabase";
    readonly name: string | null;
  }>;
};

export type SchemaSearchResultsForSqlCompletionFragment = {
  readonly __typename: "SchemaSearchResults";
  readonly schemaResultCount: number;
  readonly schemaSearchResults: ReadonlyArray<{
    readonly __typename: "DataSourceSchema";
    readonly name: string;
    readonly dataSourceDatabase: {
      readonly __typename: "DataSourceDatabase";
      readonly name: string | null;
    };
  }>;
};

export type TableSearchResultsForSqlCompletionFragment = {
  readonly __typename: "TableSearchResults";
  readonly tableResultCount: number;
  readonly tableSearchResults: ReadonlyArray<{
    readonly __typename: "DataSourceTable";
    readonly name: string;
    readonly dataSourceSchema: {
      readonly __typename: "DataSourceSchema";
      readonly name: string;
      readonly dataSourceDatabase: {
        readonly __typename: "DataSourceDatabase";
        readonly name: string | null;
      };
    };
  }>;
};

export type ColumnSearchResultsForSqlCompletionFragment = {
  readonly __typename: "ColumnSearchResults";
  readonly columnResultCount: number;
  readonly columnSearchResults: ReadonlyArray<{
    readonly __typename: "DataSourceColumn";
    readonly name: string;
    readonly type: string;
    readonly dataSourceTable: {
      readonly __typename: "DataSourceTable";
      readonly name: string;
      readonly dataSourceSchema: {
        readonly __typename: "DataSourceSchema";
        readonly name: string;
      };
    };
  }>;
};

export const DatabaseSearchResultsForSqlCompletionFragmentDoc = /*#__PURE__*/ gql`
  fragment DatabaseSearchResultsForSqlCompletion on DatabaseSearchResults {
    databaseResultCount
    databaseSearchResults {
      name
    }
  }
`;
export const SchemaSearchResultsForSqlCompletionFragmentDoc = /*#__PURE__*/ gql`
  fragment SchemaSearchResultsForSqlCompletion on SchemaSearchResults {
    schemaResultCount
    schemaSearchResults {
      name
      dataSourceDatabase {
        name
      }
    }
  }
`;
export const TableSearchResultsForSqlCompletionFragmentDoc = /*#__PURE__*/ gql`
  fragment TableSearchResultsForSqlCompletion on TableSearchResults {
    tableResultCount
    tableSearchResults {
      name
      dataSourceSchema {
        name
        dataSourceDatabase {
          name
        }
      }
    }
  }
`;
export const ColumnSearchResultsForSqlCompletionFragmentDoc = /*#__PURE__*/ gql`
  fragment ColumnSearchResultsForSqlCompletion on ColumnSearchResults {
    columnResultCount
    columnSearchResults {
      name
      type
      dataSourceTable {
        name
        dataSourceSchema {
          name
        }
      }
    }
  }
`;
